module.exports = __webpack_public_path__ + "img/vestibulares-anteriores.4692ca86.png";